import { SmartLink } from "@selector/shared/components";
import { type FC } from "react";

import { nonBreakingSpace } from "@/settings/settings.js";

import { type IAgGridCellProps } from "../../cell-base-interfaces.js";
import ListCellContent, { type ListCellItem } from "./ListCellContent.js";
import { TableCell } from "./TableCell.js";

const HyperlinkCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  const multiValues = Array.isArray(props.value) ? props.value : [props.value];

  const items: ListCellItem[] = multiValues.map((value: string) => ({
    value:
      value && value.trim() != "" ? (
        <SmartLink to={value} forceExternal tooltip={value}>
          {value}
        </SmartLink>
      ) : (
        nonBreakingSpace
      ),
  }));

  return (
    <TableCell>
      <ListCellContent items={items} colDef={props.colDef} context={props.context} />
    </TableCell>
  );
};

export default HyperlinkCell;
